<section class="default-section">
  <article class="default-card">
    <div class="jumbotron mb-3">
      <h1 class="jumbotron-headline">Kontakt</h1>
      <p class="jumbotron-lead">
        Auf dieser Seite erfahren Sie, wie Sie mich kontaktieren können. Sie können mir auch direkt eine Nachricht über das Kontaktformular
        senden.
      </p>
    </div>

    <div class="contact">
      <div class="info">
        <h1 class="paragraph-headline">Kontaktmöglichkeiten</h1>
        <p>Sie erreichen mich schriftlich per Post, Email, telefonisch oder per Messenger:</p>
        <app-responsible-contact-details [showMap]="true" [showMessenger]="true"></app-responsible-contact-details>
      </div>

      <div class="form">
        <h1 class="paragraph-headline">Kontaktformular</h1>

        <p>Sie können mir eine Nachricht über das folgende Kontaktformular schicken:</p>

        @if (!messageSent()) {
          <form (ngSubmit)="onSendMessage()" [formGroup]="messageForm">
            <div class="form-fields">
              <mat-form-field class="mat-form-input field">
                <mat-label>Ihr Name</mat-label>
                <input #senderNameRef [maxlength]="senderNameMaxLength" formControlName="senderName" matInput required />
                @if (!messageForm.get("senderName")?.valid && messageForm.get("senderName")?.touched) {
                  <mat-error>Bitte geben Sie Ihren Namen ein.</mat-error>
                }
                <span class="character-counter">{{ senderNameRef.value.length }}/{{ senderNameMaxLength }}</span>
              </mat-form-field>

              <mat-form-field class="mat-form-input field">
                <mat-label>Ihre Email-Adresse</mat-label>
                <input #senderEmailRef [maxlength]="senderEmailMaxLength" formControlName="senderEmail" matInput required />
                @if (messageForm.get("senderEmail")?.hasError("required") && messageForm.get("senderEmail")?.touched) {
                  <mat-error>Bitte geben Sie Ihre Email-Adresse ein.</mat-error>
                }
                @if (messageForm.get("senderEmail")?.hasError("email") && messageForm.get("senderEmail")?.touched) {
                  <mat-error>Die eingegebene Emailadresse ist ungültig.</mat-error>
                }
                <span class="character-counter">{{ senderEmailRef.value.length }}/{{ senderEmailMaxLength }}</span>
              </mat-form-field>

              <mat-form-field class="mat-form-input field">
                <mat-label>Ihre Telefonnummer</mat-label>
                <input #senderPhoneRef [maxlength]="senderPhoneMaxLength" formControlName="senderPhone" matInput />
                @if (!messageForm.get("senderPhone")?.valid && messageForm.get("senderPhone")?.touched) {
                  <mat-error>
                    Das Format Ihrer Telefonnummer ist ungültig. Bitte geben Sie Ihre Nummer mit Landesvorwahl ein, z.B. +491601234567.
                  </mat-error>
                }
                <span class="character-counter">{{ senderPhoneRef.value.length }}/{{ senderPhoneMaxLength }}</span>
              </mat-form-field>

              <mat-form-field class="mat-form-input field">
                <mat-label>Kategorie</mat-label>
                <mat-select #categoryRef formControlName="categoryId" id="category" panelClass="mat-select-panel-500px">
                  <mat-option [value]="null"></mat-option>
                  @for (mesCat of messageCategories; track mesCat.id) {
                    <mat-option [value]="mesCat.id">{{ mesCat.value }}</mat-option>
                  }
                </mat-select>
                @if (!messageForm.get("category")?.valid && messageForm.get("category")?.touched) {
                  <mat-error>Please select a category.</mat-error>
                }
              </mat-form-field>
            </div>

            <mat-form-field class="mat-form-input text-input-100">
              <mat-label>Betreff</mat-label>
              <input
                #subjectRef
                [maxlength]="subjectMaxLength"
                formControlName="subject"
                matInput
                placeholder="Bitte geben Sie einen Betreff ein."
                required
                type="text" />
              @if (!messageForm.get("subject")?.valid && messageForm.get("subject")?.touched) {
                <mat-error>Bitte geben Sie einen Betreff ein.</mat-error>
              }
              <span class="character-counter">{{ subjectRef.value.length }}/{{ subjectMaxLength }}</span>
            </mat-form-field>

            <div class="NgxEditor__Wrapper editor mb-3">
              <div class="editor-toolbar-three-rows">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbarSm1"></ngx-editor-menu>
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbarSm2"></ngx-editor-menu>
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbarSm3"></ngx-editor-menu>
              </div>
              <div class="editor-toolbar-two-rows">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbarMd1"></ngx-editor-menu>
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbarMd2"></ngx-editor-menu>
              </div>
              <div class="editor-toolbar-one-row">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              </div>
              <ngx-editor-floating-menu [editor]="editor">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              </ngx-editor-floating-menu>
              <div [class]="editorExpanded() ? 'editor-container-full' : 'editor-container'">
                <ngx-editor
                  [editor]="editor"
                  formControlName="message"
                  maxlength="{{ messageMaxLength }}"
                  outputFormat="html"
                  placeholder="Bitte geben Sie eine Nachricht ein."></ngx-editor>
              </div>
              <div class="character-counter">
                <span class="show-expand-editor-link">
                  @if (editorExpanded()) {
                    <a (click)="editorExpanded.set(false)" class="hover-pointer">Editor verkleinern</a>
                  } @else {
                    <a (click)="editorExpanded.set(true)" class="hover-pointer">Editor vergrößern</a>
                  }
                  - </span
                ><span>{{ messageLength }} /{{ messageMaxLength }}</span>
              </div>
            </div>
            @if (messageLength < messageMinLength && messageControl.touched) {
              <mat-error class="mt-2 small">Bitte geben Sie mindestens {{ messageMinLength }} ein.</mat-error>
            }
            @if (messageLength > messageMaxLength) {
              <mat-error class="mt-2 small"
                >Bitte geben Sie höchstens {{ messageMaxLength }} ein. Die Formatierung verbraucht auch Zeichen.
              </mat-error>
            }
            <br />

            <app-info-card icon="error_outline">Ihre Nachricht wird unverschlüsselt per Email gesendet.</app-info-card>

            <br />

            <app-mat-icon-button
              [disabled]="!messageForm.valid"
              color="primary"
              cssClass="mb-3 mt-2"
              icon="message"
              label="Nachricht senden"
              type="submit"></app-mat-icon-button>
          </form>
        }
        <app-alerts [alerts]="alerts" [float]="false"></app-alerts>
        @if (showLoadingSpinner) {
          <app-loading-spinner
            [centered]="true"
            [float]="false"
            [message]="loadingSpinnerMessage"
            [messagesByKey]="loadingSpinnerMessagesByKey"></app-loading-spinner>
        }

        @if (messageSent()) {
          <button (click)="resetForm()" class="mt-3" color="primary" mat-flat-button>Eine weitere Nachricht senden</button>
        }
      </div>
    </div>
  </article>
</section>
